export default __webpack_public_path__ + "static/media/close-events.fe423dc7.svg";